export const IS_AUTHENTICATED = 'is_auth';
export const TAX_PROS_RETURN_PUBLIC_ID = 'tax_pros_return_public_id';
export const IS_EMPLOYEE = 'is_employee';
export const CREATED_AT = 'created_at';
export const PUBLIC_ID = 'user_public_id';
export const ANONYMOUS_ID = 'anonymous_id';
